export enum PLINKO_ATLAS_FRAMES {
  FOREGROUND = 'foreground.png',
  BALL = 'ball.png',
  NUMBER_DEFAULT = 'numbers/default.png',
  NUMBER_SYSTEM_SELECTED = 'numbers/system-selected.png',
  NUMBER_SYSTEM_SELECTED_TRANSITION = 'numbers/system-selected-transition.png',
  NUMBER_PLAYER_SELECTED = 'numbers/player-selected.png',
  NUMBER_HIT = 'numbers/match.png',
  NUMBER_HIT_TRANSITION = 'numbers/match-transition.png',
  NUMBER_GLOW = 'numbers/glow.png',
}

export enum PLINKO_TEXTURE_KEYS {
  ATLAS = 'PLINKO_ATLAS',
  NUMBER_DEFAULT = 'PLINKO_NUMBER_DEFAULT',
  NUMBER_SYSTEM_SELECTED = 'PLINKO_NUMBER_SYSTEM_SELECTED',
  NUMBER_SYSTEM_SELECTED_TRANSITION = 'PLINKO_NUMBER_SYSTEM_SELECTED_TRANSITION',
  NUMBER_PLAYER_SELECTED = 'PLINKO_NUMBER_PLAYER_SELECTED',
  NUMBER_HIT = 'PLINKO_NUMBER_HIT',
  NUMBER_HIT_TRANSITION = 'PLINKO_NUMBER_HIT_TRANSITION',
}
